import { useCallback, useMemo } from "react";
import { PurchaseReportTransactionSource } from "@snackpass/snackpass-types";
import { useDashboardContext } from "../../hooks/use-dashboard-context";
import { getDefinedSources } from "#pickers/channel-picker/lib";
import { FilterSelect2 } from "src/@/components/ui/filter-select-2";
import { Settings2 } from "lucide-react";
import { t } from '@lingui/core/macro';

export const ChannelPicker = () => {
    const { channels, setChannels } = useDashboardContext();

    const selectedSources = useMemo(
        () => new Set(channels as string[]),
        [channels],
    );

    const options = useMemo(() => getDefinedSources(), []);

    const handleOptionSelected = useCallback(
        (value: string) => {
            const newSelection = new Set(selectedSources);
            if (newSelection.has(value)) {
                newSelection.delete(value);
            } else {
                newSelection.add(value);
            }
            setChannels(
                Array.from(newSelection) as PurchaseReportTransactionSource[],
            );
        },
        [selectedSources, setChannels],
    );

    return (
        <FilterSelect2
            icon={Settings2}
            title={t`Channel`}
            selectedValues={selectedSources}
            options={options}
            onOptionSelected={handleOptionSelected}
        />
    );
};
